// eslint-disable-next-line import/no-cycle
import { ComponentNameEnum, FieldConfig } from '@/types';
// eslint-disable-next-line import/no-cycle
import {
  setCssProperty, setMediaDisplay,
} from '@/components/template-builder/setters';
// eslint-disable-next-line import/no-cycle
import {
  getClassByName,
  getCssPropertyByName,
  isMediaDisplayAlreadyRestricted,
} from '@/components/template-builder/getters';
// eslint-disable-next-line import/no-cycle
import getColorFieldConfig from '@/components/template-builder/config/fields/color-config';
// eslint-disable-next-line import/no-cycle
import mediaDisplayFieldConfig from '@/components/template-builder/config/fields/media-display-config';
// eslint-disable-next-line import/no-cycle
import { getTemplateIframeDocument } from '@/components/template-builder/utils/helpers';
// eslint-disable-next-line import/no-cycle
import { HIDE_MOBILE_ATTRIBUTE } from '@/components/template-builder/utils/constants';

const widgetSpacerFieldsConfig: Array<FieldConfig> = [
  {
    label: 'templateBuilder.fields.height',
    selector: '{SELECTOR}.spm_widget_spacer > tbody > tr > th',
    properties: [{ name: 'height', getter: getCssPropertyByName, setters: [setCssProperty] }],
    displayToggle: false,
    componentName: ComponentNameEnum.STEPPER_PX_PERCENT_SLIDER,
    options: {
      px: {
        min: 0,
        max: 500,
        step: 1,
        defaultValue: 20,
        isDefaultUnitSelected: true,
      },
    },
  },
  {
    label: 'templateBuilder.fields.backgroundColor',
    selector: '{SELECTOR}.spm_widget_spacer > tbody > tr > th',
    properties: [{ name: 'background-color', getter: getCssPropertyByName, setters: [setCssProperty] }],
    ...getColorFieldConfig(),
  },
  {
    label: 'templateBuilder.fields.mediaDisplay',
    selector: '{SELECTOR} ',
    properties: [{ name: 'show-for-', getter: getClassByName, setters: [setMediaDisplay] }],
    disableHandler: (selector: string) => getTemplateIframeDocument()?.body.getAttribute(HIDE_MOBILE_ATTRIBUTE) === 'true' || isMediaDisplayAlreadyRestricted(selector),
    disableMessage: 'templateBuilder.fields.warningMessages.disabledMobileDesign',
    ...mediaDisplayFieldConfig,
  },
];

export default widgetSpacerFieldsConfig;
